import React from "react";
import "./mc.css";
import ConnectWithUs from "../../common_components/ConnectWithUs";
import Header from "../../common_components/Header";
import Footer from "../../common_components/Footer";
import log1 from "../../assets/img/log1.jpg"
function MC() {
  return (
    <React.Fragment>
      <Header></Header>
      <div className="container atf">
        <div className="left-part">
            <img src={log1} alt="" className="img-fluid"/>
        </div>
        <div className="right-part">
            <h3>Medium of Instruction certificate</h3>
            <p>To get Medium of Instruction Certificate (or) Migration Certificate, the alumni members are requested to send a request email (with their complete postal address) furnishing the details of name, registration no. etc., to : ara@vit.ac.in 
            To get duplicate degree certificate or duplicate grade sheet, please send a mail to 
            <a href="mailto:mervin.18mis7048@vitap.ac.in"> COE</a>
        </p>
        </div>
    </div>
    <ConnectWithUs></ConnectWithUs>
      <Footer></Footer>
    </React.Fragment>
  );
}
export default MC;
